module.exports = __webpack_public_path__ + "static/play_store_border-8d63e786f09f652d1ffe686aa136f708.png";